export enum LocalStorageKey {
  SelectedStore = 'selectedStore',
  SelectedTheme = 'selectedTheme',
  SelectedPicker = 'selectedPicker',
  SelectedView = 'selectedView',
  SelectedCurrency = 'selectedCurrency',
  SelectedAreaResultTab = 'selectedAreaResultTab',
  ShowNewFeatureBanner = 'showNewFeatureBanner',
}
